export default __webpack_public_path__ + "static/media/restart.043973f5.svg";